import { mapActions, mapGetters } from 'vuex'
import Configuration from '@/agilis/util/Configuration'
import DataTableTitle from '../../applications/scrum/components/TrackerDataTable/TrackerDataTableTitle/TrackerDataTableTitle.vue'
import FormSelect from '../../agilis/components/Form/FormSelect/FormSelect.vue'
import { i18nAvailableLanguages } from '@/i18n/i18n'
import L from 'lodash'

export default {
  components: {
    DataTableTitle,
    FormSelect
  },
  data () {
    return {
      editableUserProfile: L.cloneDeep(this.$store.getters['userDataStore/userProfile']),
      editTours: false,
      userTours: L.cloneDeep(this.$store.getters['tourStore/userTours']),
      selectedTheme: ''
    }
  },
  mounted () {
    this.selectedTheme = this.editableUserProfile.settings?.theme || this.theme
  },
  computed: {
    ...mapGetters({
      'userProfile': 'userDataStore/userProfile',
      loading: 'loaderStore/loading',
      tours: 'tourStore/tours',
      userIsAdmin: 'userDataStore/userIsAdmin',
      theme: 'themeStore/getTheme',
      themesAllowed: 'configurationStore/themesAllowed'
    }),
    formFields () {
      return this.editableUserProfile.columns
    },
    languageOptions () {
      return i18nAvailableLanguages.map(l => ({ ...l, label: this.$t(l.label) }))
    },
    computedTours () {
      const tours = []
      for (const tour in this.tours) {
        tours.push({ id: tour, title: this.$t(this.tours[tour]?.title), version: this.tours[tour]?.version })
      }
      return tours.sort((a, b) => a.title.localeCompare(b.title))
    },
    themes () {
      const files = require.context('@/theme', true)
      const uniqueFolders = Array.from(new Set(files.keys().map(key => key.slice(2).split('/')[0])))
      return uniqueFolders.filter(theme => {
        // We removed dark option from select and filter by themesAllowed
        return theme !== 'dark' && this.themesAllowed.includes(theme)
      })
    }
  },
  methods: {
    ...mapActions({
      saveUserProfile: 'userDataStore/saveUserProfile',
      startLoader: 'loaderStore/startLoader',
      stopLoader: 'loaderStore/stopLoader'
    }),
    handleEditDone: async function () {
      this.startLoader({ id: 'save-user-profile' })
      try {
        this.$store.commit('tourStore/setUserTour', this.userTours)
        await this.$store.dispatch('themeStore/changeTheme', this.selectedTheme)
        this.$vuetify.theme.themes.light = this.$store.getters['themeStore/getPalette']
        this.$vuetify.theme.dark = this.editableUserProfile.settings?.useDarkColors ?? false
        this.editableUserProfile.settings.theme = this.selectedTheme
        await this.saveUserProfile(this.editableUserProfile)
      } catch (e) {
        // ... save process aborted
      }
      this.stopLoader({ id: 'save-user-profile' })
      this.goBack()
    },
    handleCancel () {
      this.goBack()
    },
    goBack () {
      this.$router.go(-1)
    },
    handleSelectChange (item) {
      // copy selected item properties to settings
      L.assign(this.editableUserProfile.settings, item)
    },
    userCanAccessProfileSetting (profileSettingId) {
      return Configuration.auth.userCanAccessProfileSetting(profileSettingId)
    }
  },

  watch: {
    userProfile () {
      this.editableUserProfile = L.cloneDeep(this.userProfile)
    }
  }
}
